<template>
  <div class="main-menu__wrapper" id="recipes-tabs-wrapper">
    <div class="nav justify-content-center main-menu">
      <router-link class="nav-item main-menu__item-wrapper" id="recipe-regular-tab" :to="{ name: 'ReceipesRegular'}" :class="{ 'router-link-exact-active': $route.name === 'ReceipesRegular'}">
        <a href="#" class="main-menu__item nav-link">Регулярное</a>
      </router-link>
      <router-link class="nav-item main-menu__item-wrapper" id="recipe-special-tab" :to="{ name: 'ReceipesSpecial'}" :class="{ 'router-link-exact-active': $route.name === 'ReceipesSpecial'}">
        <a href="#" class="main-menu__item nav-link">Специальное</a>
      </router-link>
      <!--
      <router-link class="nav-item main-menu__item-wrapper" :to="{ name: 'ReceipesPlans'}">
        <span class="main-menu__item nav-link">План питания</span>
      </router-link>
      -->
      <router-link class="nav-item main-menu__item-wrapper" id="recipe-special-partner-tab" :to="{ name: 'ReceipesSpecialPartner'}" :class="{ 'router-link-exact-active': $route.name === 'ReceipesSpecialPartner'}">
        <a href="#" class="main-menu__item nav-link">Партнерское</a>
      </router-link>
      <router-link class="nav-item main-menu__item-wrapper" id="recipe-test-tab" v-if="!getUserSevenDaysLeft" :to="{ name: 'ReceipesTest'}" :class="{ 'router-link-exact-active': $route.name === 'ReceipesTest'}">
        <span class="main-menu__item nav-link" @click="handleEmptyClick">Пробное</span>
      </router-link>

    </div>
  </div>
</template>


<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'getUserSevenDaysLeft',
    ])
  },
  watch: {
    '$route.name'(value) {
      switch (value) {
        case 'ReceipesTest': document.getElementById('recipes-tabs-wrapper').scrollLeft = document.getElementById('recipe-test-tab').offsetLeft; break;
        case 'ReceipesRegular': document.getElementById('recipes-tabs-wrapper').scrollLeft = document.getElementById('recipe-regular-tab').offsetLeft; break;
        case 'ReceipesSpecial': document.getElementById('recipes-tabs-wrapper').scrollLeft = document.getElementById('recipe-special-tab').offsetLeft; break;
        case 'ReceipesSpecialPartner': document.getElementById('recipes-tabs-wrapper').scrollLeft = document.getElementById('recipe-special-partner-tab').offsetLeft; break;
      }
    }
  },
  methods: {
    handleEmptyClick(evt) {
      if (!this.getUserSevenDaysLeft) return;
      evt.preventDefault();
      this.$root.$emit('notify', {
        type: 'red',
        text: 'Нет доступа - истёк срок подписки'
      })
    },
  }
}
</script>
